class AutocompleteAttributionCode {
  constructor(element, onSelectFunction) {
    this._element = element;
    this._onSelectFunction = onSelectFunction;
    var xhr;
    var bindOnSelectFunction = this._onSelectFunction;
    $(this._element).autoComplete({
      minChars: 2,
      source: function (term, suggest) {
        try {
          xhr.abort();
        } catch (e) {
          //aborting the xhr statement
        }
        xhr = $.getJSON('/api/Suggest/AttributionCodes?term=' + term, function (data) {
          var suggestions = [];
          for (let i = 0; i < data.length; i++) suggestions.push(data[i]);
          suggest(suggestions);
        });
      },
      renderItem: function (item, search) {
        var row = '<div class="autocomplete-suggestion suggest-search-row-striped" data-attribution-id="' + item.attributionId + '" data-display-value="' + CDXss.sanatizeInput(item.displayValue) + '" >';
        row += "<div >" + CDXss.sanatizeInput(item.displayValue) + "</div>";
        row += "</div>";
        return row;
      },
      onSelect: function (e, term, item) {
        e.preventDefault();
        bindOnSelectFunction(e, term, item);
      }
    });
  }
}
class AutocompleteEmailCampaign {
  constructor(element, onSelectFunction) {
    this._element = element;
    this._onSelectFunction = onSelectFunction;
    var xhr;
    var bindOnSelectFunction = this._onSelectFunction;
    $(this._element).autoComplete({
      minChars: 2,
      source: function (term, suggest) {
        try {
          xhr.abort();
        } catch (e) {
          //aborting the xhr statement
        }
        xhr = $.getJSON('/api/Suggest/EmailCampaigns?term=' + term, function (data) {
          var suggestions = [];
          for (let i = 0; i < data.length; i++) suggestions.push(data[i]);
          suggest(suggestions);
        });
      },
      renderItem: function (item, search) {
        var row = '<div class="autocomplete-suggestion suggest-search-row-striped" data-message-campaign-id="' + item.messageCampaignId + '" data-display-value="' + CDXss.sanatizeInput(item.displayValue) + '" >';
        row += "<div >" + CDXss.sanatizeInput(item.displayValue) + "</div>";
        row += "</div>";
        return row;
      },
      onSelect: function (e, term, item) {
        e.preventDefault();
        bindOnSelectFunction(e, term, item);
      }
    });
  }
}
class AutocompleteFormName {
  constructor(element, onSelectFunction) {
    this._element = element;
    this._onSelectFunction = onSelectFunction;
    var xhr;
    var bindOnSelectFunction = this._onSelectFunction;
    $(this._element).autoComplete({
      minChars: 2,
      source: function (term, suggest) {
        try {
          xhr.abort();
        } catch (e) {
          //aborting the xhr statement
        }
        xhr = $.getJSON('/api/Suggest/FormNames?term=' + term, function (data) {
          var suggestions = [];
          for (let i = 0; i < data.length; i++) suggestions.push(data[i]);
          suggest(suggestions);
        });
      },
      renderItem: function (item, search) {
        var row = '<div class="autocomplete-suggestion suggest-search-row-striped" data-form-id="' + item.formId + '" data-display-value="' + CDXss.sanatizeInput(item.displayValue) + '" >';
        row += "<div >" + CDXss.sanatizeInput(item.displayValue) + "</div>";
        row += "</div>";
        return row;
      },
      onSelect: function (e, term, item) {
        e.preventDefault();
        bindOnSelectFunction(e, term, item);
      }
    });
  }
}
class OrganizationAutoCompletev2 {
  constructor(id, hiddenId, onSelectFunction) {
    this._id = id;
    this._hiddenId = hiddenId;
    this._onSelectFunction = onSelectFunction;
    var xhr;
    var bindOnSelectFunction = this._onSelectFunction;
    $(this._id).autoComplete({
      minChars: 2,
      source: function (term, suggest) {
        try {
          xhr.abort();
        } catch (e) {
          //aborting the xhr statement
        }
        xhr = $.getJSON('/api/Suggest/Organizations?term=' + term, {
          q: term
        }, function (data) {
          var suggestions = [];
          for (let i = 0; i < data.length; i++) suggestions.push(data[i]);
          suggest(suggestions);
        });
      },
      renderItem: function (item, search) {
        var row = '<div class="autocomplete-suggestion suggest-search-row-striped" data-organization-id="' + item.organizationId + '" data-display-value="' + CDXss.sanatizeInput(item.displayValue) + '" >';
        row += "<div ><i class=\"fa fa-building\" aria-hidden=\"true\"></i></i> " + CDXss.sanatizeInput(item.displayValue) + "</div>";
        if (item.address) {
          if (item.address.deliveryLine1) {
            row += "<div class=\"address\">" + CDXss.sanatizeInput(item.address.deliveryLine1) + "</div>";
          }
          if (item.address.city || item.address.state) {
            row += "<div class=\"address\">" + CDXss.sanatizeInput(item.address.city) + ", " + CDXss.sanatizeInput(item.address.stateAbbreviation) + "</div>";
          }
        }
        row += "</div>";
        return row;
      },
      onSelect: function (e, term, item) {
        e.preventDefault();
        bindOnSelectFunction(e, term, item);
      }
    });
  }
}
class UserAutocomplete {
  constructor(id, hiddenId, onSelectFunction) {
    this._id = id;
    this._hiddenId = hiddenId;
    this._onSelectFunction = onSelectFunction;
    var xhr;
    var bindOnSelectFunction = this._onSelectFunction;
    var jqueryNode = null;

    //if (typeof id === 'string') {
    //    jqueryNode = $(this._id);
    //} else {

    //}

    $(this._id).autoComplete({
      minChars: 2,
      source: function (term, suggest) {
        try {
          xhr.abort();
        } catch (e) {
          //aborting the xhr statement
        }
        xhr = $.getJSON('/api/Suggest/Users?term=' + term, {
          q: term
        }, function (data) {
          var suggestions = [];
          for (let i = 0; i < data.length; i++) suggestions.push(data[i]);
          suggest(suggestions);
        });
      },
      renderItem: function (item, search) {
        var row = '<div class="autocomplete-suggestion suggest-search-row-striped" data-user-id="' + item.userId + '" data-first-Name="' + CDXss.sanatizeInput(item.firstName) + '" data-last-name="' + CDXss.sanatizeInput(item.lastName) + '" >';
        row += "<div ><i class=\"fa fa-user\" aria-hidden=\"true\"></i> " + CDXss.sanatizeInput(item.firstName) + " " + CDXss.sanatizeInput(item.lastName) + "</div>";
        row += "<div class=\"email-address\">" + CDXss.sanatizeInput(item.email) + "</div>";
        row += "</div>";
        return row;
      },
      onSelect: function (e, term, item) {
        e.preventDefault();
        bindOnSelectFunction(e, term, item);
      }
    });
  }
}
class CDBeep {
  constructor(options) {
    this.FREQUENCY = 440;
    this.INTERVAL = 250;
    this.RAMP_VALUE = 0.00001;
    this.RAMP_DURATION = 1;
    if (!options) options = {};
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    this.context = options.context || new window.AudioContext();
    this.frequency = options.frequency || this.FREQUENCY;
    this.interval = options.interval || this.INTERVAL;
  }
  play() {
    var currentTime = this.context.currentTime;
    var osc = this.context.createOscillator();
    var gain = this.context.createGain();
    osc.connect(gain);
    gain.connect(this.context.destination);
    gain.gain.setValueAtTime(gain.gain.value, currentTime);
    gain.gain.exponentialRampToValueAtTime(this.RAMP_VALUE, currentTime + this.RAMP_DURATION);
    osc.onended = function () {
      gain.disconnect(this.context.destination);
      osc.disconnect(gain);
    };
    osc.type = 'sine';
    osc.frequency.value = this.frequency;
    osc.start(currentTime);
    osc.stop(currentTime + this.RAMP_DURATION);
  }
  beep(times) {
    if (!times) times = 1;
    ;
    (function loop(i) {
      play();
      if (++i < times) setTimeout(loop, interval, i);
    })(0);
  }
  destroy() {
    if (!options.context) this.context.close();
  }
}
class CDUserEvents {
  constructor() {}
  setUser(userId) {
    try {
      amplitude.getInstance().setUserId(userId);
    } catch (error) {
      console.error(error);
    }
  }
  logEvent(eventName, eventProperties) {
    try {
      if (eventProperties) {
        amplitude.getInstance().logEvent(eventName, eventProperties);
      } else {
        amplitude.getInstance().logEvent(eventName);
      }
    } catch (error) {
      console.error(error);
    }
  }
  destroy() {}
}
class EventService {
  constructor() {}
  getHosts(eventId, doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/event/${eventId}/Host`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  addHost(eventId, personId, doneFunction, failFunction, alwaysFunction) {
    var data = JSON.stringify({
      personId: personId
    });
    $.ajax({
      url: `/api/event/${eventId}/Host`,
      type: 'PUT',
      contentType: 'application/json',
      data: data
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  removeHost(eventId, personId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/event/${eventId}/Host/${personId}`,
      type: 'DELETE',
      contentType: 'application/json'
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  addGuest(eventId, personId, doneFunction, failFunction, alwaysFunction) {
    var data = JSON.stringify({
      personId: personId
    });
    $.ajax({
      url: `/api/event/${eventId}/Guest`,
      type: 'PUT',
      contentType: 'application/json',
      data: data
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  addGuests(eventId, personIds, doneFunction, failFunction, alwaysFunction) {
    var data = JSON.stringify({
      personIds: personIds
    });
    $.ajax({
      url: `/api/event/${eventId}/Guests`,
      type: 'PUT',
      contentType: 'application/json',
      data: data
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  updateGuestsStatus(eventId, statusId, personIds, doneFunction, failFunction, alwaysFunction) {
    var data = JSON.stringify({
      personIds: personIds,
      status: statusId
    });
    $.ajax({
      url: `/api/event/${eventId}/Guests/Status`,
      type: 'POST',
      contentType: 'application/json',
      data: data
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  updateGuestCount(eventId, personId, guestCount, doneFunction, failFunction, alwaysFunction) {
    var data = JSON.stringify({
      personId: personId,
      guestCount: guestCount
    });
    $.ajax({
      url: `/api/event/${eventId}/Guests/Count`,
      type: 'POST',
      contentType: 'application/json',
      data: data
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  removeGuest(eventId, personId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/event/${eventId}/Guest/${personId}`,
      type: 'DELETE',
      contentType: 'application/json'
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  getGuests(eventId, doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/event/${eventId}/Guest`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  getGuestResponses(eventId) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/event/${eventId}/Guest`).then(response => {
        resolve({
          responses: response.data.responses
        });
      }).catch(function (error) {
        reject({
          error: error
        });
      });
    });
  }
  getEvents(doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/events/`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  getEventsByPerson(personId, doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/event/person/${personId}`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
}
/*! JSONPatcherProxy version: 0.0.9 */
var JSONPatcherProxy = /******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // identity function for calling harmony imports with the correct context
  /******/
  __webpack_require__.i = function (value) {
    return value;
  };
  /******/
  /******/ // define getter function for harmony exports
  /******/
  __webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        /******/configurable: false,
        /******/enumerable: true,
        /******/get: getter
        /******/
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/
  __webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ? /******/function getDefault() {
      return module['default'];
    } : /******/function getModuleExports() {
      return module;
    };
    /******/
    __webpack_require__.d(getter, 'a', getter);
    /******/
    return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "";
  /******/
  /******/ // Load entry module and return exports
  /******/
  return __webpack_require__(__webpack_require__.s = 0);
  /******/
}
/************************************************************************/
/******/([/* 0 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /*!
   * https://github.com/Palindrom/JSONPatcherProxy
   * (c) 2017 Starcounter 
   * MIT license
   */

  /** Class representing a JS Object observer  */
  const JSONPatcherProxy = function () {
    /**
    * Deep clones your object and returns a new object.
    */
    function deepClone(obj) {
      switch (typeof obj) {
        case 'object':
          return JSON.parse(JSON.stringify(obj));
        //Faster than ES5 clone - http://jsperf.com/deep-cloning-of-objects/5
        case 'undefined':
          return null;
        //this is how JSON.stringify behaves for array items
        default:
          return obj;
        //no need to clone primitives
      }
    }

    JSONPatcherProxy.deepClone = deepClone;
    function escapePathComponent(str) {
      if (str.indexOf('/') == -1 && str.indexOf('~') == -1) return str;
      return str.replace(/~/g, '~0').replace(/\//g, '~1');
    }
    JSONPatcherProxy.escapePathComponent = escapePathComponent;

    /**
     * Walk up the parenthood tree to get the path
     * @param {JSONPatcherProxy} instance 
     * @param {Object} obj the object you need to find its path
     */
    function findObjectPath(instance, obj) {
      const pathComponents = [];
      let parentAndPath = instance.parenthoodMap.get(obj);
      while (parentAndPath && parentAndPath.path) {
        // because we're walking up-tree, we need to use the array as a stack
        pathComponents.unshift(parentAndPath.path);
        parentAndPath = instance.parenthoodMap.get(parentAndPath.parent);
      }
      if (pathComponents.length) {
        const path = pathComponents.join('/');
        return '/' + path;
      }
      return '';
    }
    /**
     * A callback to be used as th proxy set trap callback.
     * It updates parenthood map if needed, proxifies nested newly-added objects, calls default callbacks with the changes occurred.
     * @param {JSONPatcherProxy} instance JSONPatcherProxy instance
     * @param {Object} target the affected object
     * @param {String} key the effect property's name
     * @param {Any} newValue the value being set
     */
    function setTrap(instance, target, key, newValue) {
      const parentPath = findObjectPath(instance, target);
      const destinationPropKey = parentPath + '/' + escapePathComponent(key);
      if (instance.proxifiedObjectsMap.has(newValue)) {
        const newValueOriginalObject = instance.proxifiedObjectsMap.get(newValue);
        instance.parenthoodMap.set(newValueOriginalObject.originalObject, {
          parent: target,
          path: key
        });
      }
      /*
          mark already proxified values as inherited.
          rationale: proxy.arr.shift()
          will emit
          {op: replace, path: '/arr/1', value: arr_2}
          {op: remove, path: '/arr/2'}
            by default, the second operation would revoke the proxy, and this renders arr revoked.
          That's why we need to remember the proxies that are inherited.
        */
      const revokableInstance = instance.proxifiedObjectsMap.get(newValue);
      /*
      Why do we need to check instance.isProxifyingTreeNow?
        We need to make sure we mark revokables as inherited ONLY when we're observing,
      because throughout the first proxification, a sub-object is proxified and then assigned to 
      its parent object. This assignment of a pre-proxified object can fool us into thinking
      that it's a proxified object moved around, while in fact it's the first assignment ever. 
        Checking isProxifyingTreeNow ensures this is not happening in the first proxification, 
      but in fact is is a proxified object moved around the tree
      */
      if (revokableInstance && !instance.isProxifyingTreeNow) {
        revokableInstance.inherited = true;
      }

      // if the new value is an object, make sure to watch it
      if (newValue && typeof newValue == 'object' && !instance.proxifiedObjectsMap.has(newValue)) {
        instance.parenthoodMap.set(newValue, {
          parent: target,
          path: key
        });
        newValue = instance._proxifyObjectTreeRecursively(target, newValue, key);
      }
      // let's start with this operation, and may or may not update it later
      const operation = {
        op: 'remove',
        path: destinationPropKey
      };
      if (typeof newValue == 'undefined') {
        // applying De Morgan's laws would be a tad faster, but less readable
        if (!Array.isArray(target) && !target.hasOwnProperty(key)) {
          // `undefined` is being set to an already undefined value, keep silent
          return Reflect.set(target, key, newValue);
        } else {
          // when array element is set to `undefined`, should generate replace to `null`
          if (Array.isArray(target)) {
            // undefined array elements are JSON.stringified to `null`
            operation.op = 'replace', operation.value = null;
          }
          const oldValue = instance.proxifiedObjectsMap.get(target[key]);
          // was the deleted a proxified object?
          if (oldValue) {
            instance.parenthoodMap.delete(target[key]);
            instance.disableTrapsForProxy(oldValue);
            instance.proxifiedObjectsMap.delete(oldValue);
          }
        }
      } else {
        if (Array.isArray(target) && !Number.isInteger(+key.toString())) {
          /* array props (as opposed to indices) don't emit any patches, to avoid needless `length` patches */
          return Reflect.set(target, key, newValue);
        }
        operation.op = 'add';
        if (target.hasOwnProperty(key)) {
          if (typeof target[key] !== 'undefined' || Array.isArray(target)) {
            operation.op = 'replace'; // setting `undefined` array elements is a `replace` op
          }
        }

        operation.value = newValue;
      }
      const reflectionResult = Reflect.set(target, key, newValue);
      instance.defaultCallback(operation);
      return reflectionResult;
    }
    /**
     * A callback to be used as th proxy delete trap callback.
     * It updates parenthood map if needed, calls default callbacks with the changes occurred.
     * @param {JSONPatcherProxy} instance JSONPatcherProxy instance
     * @param {Object} target the effected object
     * @param {String} key the effected property's name
     */
    function deleteTrap(instance, target, key) {
      if (typeof target[key] !== 'undefined') {
        const parentPath = findObjectPath(instance, target);
        const destinationPropKey = parentPath + '/' + escapePathComponent(key);
        const revokableProxyInstance = instance.proxifiedObjectsMap.get(target[key]);
        if (revokableProxyInstance) {
          if (revokableProxyInstance.inherited) {
            /*
              this is an inherited proxy (an already proxified object that was moved around), 
              we shouldn't revoke it, because even though it was removed from path1, it is still used in path2.
              And we know that because we mark moved proxies with `inherited` flag when we move them
                it is a good idea to remove this flag if we come across it here, in deleteProperty trap.
              We DO want to revoke the proxy if it was removed again.
            */
            revokableProxyInstance.inherited = false;
          } else {
            instance.parenthoodMap.delete(revokableProxyInstance.originalObject);
            instance.disableTrapsForProxy(revokableProxyInstance);
            instance.proxifiedObjectsMap.delete(target[key]);
          }
        }
        const reflectionResult = Reflect.deleteProperty(target, key);
        instance.defaultCallback({
          op: 'remove',
          path: destinationPropKey
        });
        return reflectionResult;
      }
    }
    /* pre-define resume and pause functions to enhance constructors performance */
    function resume() {
      this.defaultCallback = operation => {
        this.isRecording && this.patches.push(operation);
        this.userCallback && this.userCallback(operation);
      };
      this.isObserving = true;
    }
    function pause() {
      this.defaultCallback = () => {};
      this.isObserving = false;
    }
    /**
      * Creates an instance of JSONPatcherProxy around your object of interest `root`. 
      * @param {Object|Array} root - the object you want to wrap
      * @param {Boolean} [showDetachedWarning = true] - whether to log a warning when a detached sub-object is modified @see {@link https://github.com/Palindrom/JSONPatcherProxy#detached-objects} 
      * @returns {JSONPatcherProxy}
      * @constructor
      */
    function JSONPatcherProxy(root, showDetachedWarning) {
      this.isProxifyingTreeNow = false;
      this.isObserving = false;
      this.proxifiedObjectsMap = new Map();
      this.parenthoodMap = new Map();
      // default to true
      if (typeof showDetachedWarning !== 'boolean') {
        showDetachedWarning = true;
      }
      this.showDetachedWarning = showDetachedWarning;
      this.originalObject = root;
      this.cachedProxy = null;
      this.isRecording = false;
      this.userCallback;
      /**
       * @memberof JSONPatcherProxy
       * Restores callback back to the original one provided to `observe`.
       */
      this.resume = resume.bind(this);
      /**
       * @memberof JSONPatcherProxy
       * Replaces your callback with a noop function.
       */
      this.pause = pause.bind(this);
    }
    JSONPatcherProxy.prototype.generateProxyAtPath = function (parent, obj, path) {
      if (!obj) {
        return obj;
      }
      const traps = {
        set: (target, key, value, receiver) => setTrap(this, target, key, value, receiver),
        deleteProperty: (target, key) => deleteTrap(this, target, key)
      };
      const revocableInstance = Proxy.revocable(obj, traps);
      // cache traps object to disable them later.
      revocableInstance.trapsInstance = traps;
      revocableInstance.originalObject = obj;

      /* keeping track of object's parent and path */

      this.parenthoodMap.set(obj, {
        parent,
        path
      });

      /* keeping track of all the proxies to be able to revoke them later */
      this.proxifiedObjectsMap.set(revocableInstance.proxy, revocableInstance);
      return revocableInstance.proxy;
    };
    // grab tree's leaves one by one, encapsulate them into a proxy and return
    JSONPatcherProxy.prototype._proxifyObjectTreeRecursively = function (parent, root, path) {
      for (let key in root) {
        if (root.hasOwnProperty(key)) {
          if (root[key] instanceof Object) {
            root[key] = this._proxifyObjectTreeRecursively(root, root[key], escapePathComponent(key));
          }
        }
      }
      return this.generateProxyAtPath(parent, root, path);
    };
    // this function is for aesthetic purposes
    JSONPatcherProxy.prototype.proxifyObjectTree = function (root) {
      /*
      while proxyifying object tree,
      the proxyifying operation itself is being
      recorded, which in an unwanted behavior,
      that's why we disable recording through this
      initial process;
      */
      this.pause();
      this.isProxifyingTreeNow = true;
      const proxifiedObject = this._proxifyObjectTreeRecursively(undefined, root, '');
      /* OK you can record now */
      this.isProxifyingTreeNow = false;
      this.resume();
      return proxifiedObject;
    };
    /**
     * Turns a proxified object into a forward-proxy object; doesn't emit any patches anymore, like a normal object
     * @param {Proxy} proxy - The target proxy object
     */
    JSONPatcherProxy.prototype.disableTrapsForProxy = function (revokableProxyInstance) {
      if (this.showDetachedWarning) {
        const message = "You're accessing an object that is detached from the observedObject tree, see https://github.com/Palindrom/JSONPatcherProxy#detached-objects";
        revokableProxyInstance.trapsInstance.set = (targetObject, propKey, newValue) => {
          console.warn(message);
          return Reflect.set(targetObject, propKey, newValue);
        };
        revokableProxyInstance.trapsInstance.set = (targetObject, propKey, newValue) => {
          console.warn(message);
          return Reflect.set(targetObject, propKey, newValue);
        };
        revokableProxyInstance.trapsInstance.deleteProperty = (targetObject, propKey) => {
          return Reflect.deleteProperty(targetObject, propKey);
        };
      } else {
        delete revokableProxyInstance.trapsInstance.set;
        delete revokableProxyInstance.trapsInstance.get;
        delete revokableProxyInstance.trapsInstance.deleteProperty;
      }
    };
    /**
     * Proxifies the object that was passed in the constructor and returns a proxified mirror of it. Even though both parameters are options. You need to pass at least one of them.
     * @param {Boolean} [record] - whether to record object changes to a later-retrievable patches array.
     * @param {Function} [callback] - this will be synchronously called with every object change with a single `patch` as the only parameter.
     */
    JSONPatcherProxy.prototype.observe = function (record, callback) {
      if (!record && !callback) {
        throw new Error('You need to either record changes or pass a callback');
      }
      this.isRecording = record;
      this.userCallback = callback;
      /*
      I moved it here to remove it from `unobserve`,
      this will also make the constructor faster, why initiate
      the array before they decide to actually observe with recording?
      They might need to use only a callback.
      */
      if (record) this.patches = [];
      this.cachedProxy = this.proxifyObjectTree(this.originalObject);
      return this.cachedProxy;
    };
    /**
     * If the observed is set to record, it will synchronously return all the patches and empties patches array.
     */
    JSONPatcherProxy.prototype.generate = function () {
      if (!this.isRecording) {
        throw new Error('You should set record to true to get patches later');
      }
      return this.patches.splice(0, this.patches.length);
    };
    /**
     * Revokes all proxies rendering the observed object useless and good for garbage collection @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/revocable}
     */
    JSONPatcherProxy.prototype.revoke = function () {
      this.proxifiedObjectsMap.forEach(el => {
        el.revoke();
      });
    };
    /**
     * Disables all proxies' traps, turning the observed object into a forward-proxy object, like a normal object that you can modify silently.
     */
    JSONPatcherProxy.prototype.disableTraps = function () {
      this.proxifiedObjectsMap.forEach(this.disableTrapsForProxy, this);
    };
    return JSONPatcherProxy;
  }();
  if (true) {
    module.exports = JSONPatcherProxy;
    module.exports.default = JSONPatcherProxy;
  }

  /***/
}
/******/]);
class ListService {
  constructor() {}
  getLists(doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/v2/List`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  getPersons(listId, doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/v2/List/${listId}`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  addPersons(listId, personIds, doneFunction, failFunction, alwaysFunction) {
    var data = JSON.stringify({
      personIds: personIds
    });
    $.ajax({
      url: `/api/v2/List/${listId}/Persons`,
      type: 'PUT',
      contentType: 'application/json',
      data: data
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  addPerson(listId, personId, doneFunction, failFunction, alwaysFunction) {
    axios.put(`/api/v2/List/${listId}/Person`, {
      personIds: [personId]
    }).then(function (response) {
      if (doneFunction) doneFunction(response.data, response);
      //response.data.messagePreview.length;
    }).catch(function (error) {
      //var err = textStatus + ", " + error;
      console.log("Request Failed: " + error);
      if (failFunction) failFunction(error, error.response.status, error.response.data);
    }).finally(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
}
class LogDeputy {
  constructor(prefix, consoleLogLevel, serverLogLevel, serverUrl) {
    this._prefix = prefix;
    this._consoleLogLevel = consoleLogLevel;
    this._serverLogLevel = serverLogLevel;
    this._serverUrl = serverUrl;
    console.log(serverUrl);
  }
  log(logLevel, message) {
    if (logLevel >= this._consoleLogLevel) {
      console.log(`${this._prefix}: ${logLevel} ${message}`);
    }
    if (logLevel >= this._serverLogLevel) {
      axios.post(`${this._serverUrl}/api/logs/log/`, {
        prefix: this._prefix,
        logLevel: logLevel,
        message: message
      }).catch(function (error) {
        console.log(error);
      });

      //console.log(`${this._prefix}-Server: ${logLevel} ${message}`);
    }
  }
}

/*
 * export enum LogLevel {
     Log level for very low severity diagnostic messages. 
    Trace = 0,
    Log level for low severity diagnostic messages. 
    Debug = 1,
    Log level for informational diagnostic messages. 
    Information = 2,
    Log level for diagnostic messages that indicate a non-fatal problem. 
    Warning = 3,
    Log level for diagnostic messages that indicate a failure in the current operation. 
    Error = 4,
     Log level for diagnostic messages that indicate a failure that will terminate the entire application. 
    Critical = 5,
    The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. 
    None = 6,
*/
class NotificationHandler {
  constructor(accountKey, userKey) {
    this._accountKey = accountKey;
    this._userKey = userKey;
    this._processedNotifications = new Set();
    this._bc = new BroadcastChannel('notifications_channel');
    this._pendingTimers = new Map();
    this._bc.onmessage = event => {
      const notification = event.data;
      if (!this._processedNotifications.has(notification.id)) {
        this._processedNotifications.add(notification.id);
      }
    };
  }
  recentNotifications(notifications) {
    console.log(notifications); //TODO compare these with the localStorage notifications and add in missing ones sorted by date time.
    let storedNotifications = this.loadLocalStorageNotifications();

    // Create a map of stored notifications by their IDs for quick lookup
    let storedNotificationsMap = new Map(storedNotifications.map(notification => [notification.notificationId, notification]));

    // Add new notifications that are not in the stored notifications
    notifications.forEach(notification => {
      if (!storedNotificationsMap.has(notification.notificationId)) {
        storedNotifications.push(notification);
      }
    });

    // Sort the notifications by timestamp and keep the top 5
    storedNotifications.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));
    storedNotifications = storedNotifications.slice(0, 2);
    this.renderNotifications(storedNotifications);
    this.storeNotifications(storedNotifications);
  }
  localStorateKey() {
    return `notifications-${this._accountKey}-${this._userKey}`;
  }
  loadLocalStorageNotifications() {
    return JSON.parse(localStorage.getItem(this.localStorateKey())) || [];
  }
  storeNotifications(notifications) {
    localStorage.setItem(this.localStorateKey(), JSON.stringify(notifications));
  }
  loadNotifications() {
    let notifications = JSON.parse(localStorage.getItem(this.localStorateKey())) || [];

    // Sort the notifications by timestamp and keep the top 5
    notifications.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));
    notifications = notifications.slice(0, 2);
    this.renderNotifications(notifications);
  }
  renderNotifications(notifications) {
    var html = ejs.render(`
        <% notifications.forEach(function(notification, i) {%>
             
            <a href="<%= notification.permalink %>" class="dropdown-item preview-item d-flex pr-2 my-2">
            <div class="preview-thumbnail" style="display:inline-block">
            <div class="preview-icon bg-white rounded-circle" style="a">
            <i class="fal fa-<%= notification.iconName %>"></i>
            </div>
            </div>
            <div class="w-100" style="display:inline-block;margin-left:4px;">
            <div class="d-flex justify-content-between mb-1 w-100" style="line-height:20px">
                <div class="preview-subject"><%= notification.title %></div>
                <div class="text-muted font-12 pl-4"><%= new Date(notification.dateTime).toLocaleString("en-US", {                     
                    year: "2-digit", 
                    month: "numeric", 
                    day: "numeric", 
                    hour: "2-digit", 
                    minute: "2-digit", 
                    hour12: true  
                })
                %>
                </div>
            </div>    
            <p class="text-muted ellipsis mb-0"><%= notification.message %></p>
            </div>
            </a> 
        <% }); %>`, {
      notifications: notifications
    });
    $("#notification-item-container").html(html);
  }
  showToast(notification) {
    if (notification.alertUser === false) {
      return;
    }
    let buttonText = "";
    if (notification.permaLink && notification.permaLink.trim() !== "") {
      buttonText = "View";
    } else if (notification.notificationType === 1) {
      buttonText = "Download";
    }
    Toastify({
      text: notification.title,
      duration: 4000,
      destination: notification.permalink,
      buttonText: buttonText,
      newWindow: true,
      close: true,
      gravity: "top",
      // `top` or `bottom`
      position: "center",
      // `left`, `center` or `right`
      stopOnFocus: true,
      // Prevents dismissing of toast on hover
      style: {
        background: ""
      },
      avatar: `<i class="fal fa-${notification.iconName}"></i>`
      //onClick: function(){} // Callback after click
    }).showToast();
  }
  handleNotification(notification) {
    if (this._processedNotifications.has(notification.id)) {
      //another tab had this already
      console.log("Message already processed");
      this.showToast(notification);
      return;
    }
    this._bc.postMessage(notification);
    // Mark it as processed
    this._processedNotifications.add(notification.id);
    console.log(notification);
    this.showToast(notification);
    const delay = Math.floor(Math.random() * 75);
    const timer = setTimeout(() => {
      //add a bit of delay before we manipulate the local storage
      // Remove the timer from our map now that it fired
      //pendingTimers.delete(notification.id);

      let notifications = JSON.parse(localStorage.getItem(this.localStorateKey())) || [];
      let notificationIds = new Set(notifications.map(n => n.notificationId));
      if (!notificationIds.has(notification.notificationId)) {
        //don't recreate the notification if it already exists
        notifications.push(notification);
        // Sort the notifications by timestamp and keep the top 5
        notifications.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));
        notifications = notifications.slice(0, 5);
        this.renderNotifications(notifications);
        this.storeNotifications(notifications);
      } else {
        notifications.push(notification);
        this.renderNotifications(notifications);
      }
    }, delay);
  }
}
class PersonService {
  constructor() {}
  get(personId, doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/Persons/v2/${personId}`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  patch(personId, patchDocument, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      method: "PATCH",
      url: `/api/Persons/v2/${personId}`,
      data: JSON.stringify(patchDocument),
      contentType: "application/json",
      dataType: "json",
      processData: false
    }).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  getCalls(personId, doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/Persons/v2/${personId}/CallLog`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  removeNote(noteid, personId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/note/${noteid}`,
      type: 'DELETE',
      contentType: 'application/json'
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  updateNote(noteid, personId, note, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/note/${noteid}`,
      type: 'POST',
      data: JSON.stringify({
        noteId: noteid,
        note: note
      }),
      contentType: "application/json",
      dataType: "json"
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  removeSpouse(personId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/spouse/`,
      type: 'DELETE',
      contentType: 'application/json'
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  addSpouse(personId, spouseId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/spouse/${spouseId}`,
      type: 'POST',
      //data: JSON.stringify({ noteId: noteid, note: note }),
      contentType: "application/json",
      dataType: "json"
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  removePrincipal(personId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/principal/`,
      type: 'DELETE',
      contentType: 'application/json'
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  addPrincipal(personId, userId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/principal/`,
      type: 'POST',
      data: {
        userId: userId
      }
      //contentType: "application/json",
      //dataType: "json",
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  updateAddress(personId, address, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/address/`,
      type: 'POST',
      data: JSON.stringify({
        isPrimary: address.isPrimary,
        deliveryLine1: address.deliveryLine1,
        city: address.city,
        stateProvinceAbbreviation: address.stateProvinceAbbreviation,
        postalCode: address.postalCode,
        addressStatus: address.addressStatus
      }),
      contentType: "application/json",
      dataType: "json"
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  flag(personId, flag, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/flag/`,
      type: 'POST',
      data: JSON.stringify({
        doNotSend: flag.doNotSend,
        deceased: flag.deceased
      }),
      contentType: "application/json",
      dataType: "json"
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  emailStatistics(personId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/v2/${personId}/email/statistics`,
      type: 'POST',
      contentType: "application/json",
      dataType: "json"
    }).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  getCustomFields(personId, doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/Persons/v2/${personId}/customfields/`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  updateCustomFields(personId, customFields, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/v2/${personId}/customfields/`,
      type: 'POST',
      data: customFields
      //contentType: "application/json",
      //dataType: "json"
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  updateCustomFields(personId, customFields, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/v2/${personId}/customfields/`,
      type: 'POST',
      data: customFields
      //contentType: "application/json",
      //dataType: "json"
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  addActivity(personId, activity, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/activity/`,
      type: 'PUT',
      data: JSON.stringify(activity),
      contentType: "application/json",
      dataType: "json"
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  getActivitiesByPerson(personId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/activity/`,
      type: 'GET'
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  deletePersonActivity(personId, activityId, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/Persons/${personId}/activity/${activityId}`,
      type: 'DELETE'
    }).done(function (data) {
      if (doneFunction) doneFunction(data);
    }).fail(function () {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
}
class RealTimeDeputy {
  constructor(serverUrl, logLevel, serverLogUrl, notificationManager) {
    this._notificationManager = notificationManager;
    this._connection = new signalR.HubConnectionBuilder().withUrl(serverUrl, {
      accessTokenFactory: () => {
        return axios.post('/api/User/SignalR').then(function (response) {
          return response.data.accessToken;
        });
      },
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets
    }).configureLogging(new LogDeputy("SignalR", logLevel, 3, serverLogUrl)).withAutomaticReconnect().build();
    this._connection.start().then(() => {
      this.sendAliveNotice();
      this.getRecentNotifications();
    });
    this._connection.on("PhoneMessage", message => {
      console.log(`PhoneMessage:${message}`);
    });
    this._connection.on("ReceiveNotification", notification => {
      console.log(`notification received:`);
      this._notificationManager.handleNotification(notification);
      this.acknowledgeNotification(notification.notificationId);
    });
    this._connection.on("AliveNotice", userContext => {
      console.log(`AliveNotice received ${userContext}`);
    });
  }
  sendAliveNotice() {
    this._connection.invoke("AliveNotice");
  }
  getRecentNotifications() {
    this._connection.invoke("GetRecentNotifications").then(notifications => {
      this._notificationManager.recentNotifications(notifications);
    }).catch(function (error) {
      console.log('Error: ' + error);
    });
  }
  acknowledgeNotification(notificationId) {
    this._connection.invoke("AcknowledgeNotification", {
      notificationId: notificationId,
      timestamp: new Date(),
      acknowledged: true
    });
  }
  markNotificationRead(notificationId) {
    this._connection.invoke("AcknowledgeNotification", {
      notificationId: notificationId,
      timestamp: new Date(),
      read: true
    });
  }
}
class RealTimeService {
  constructor(appId, cluster) {
    this.pusher = new Pusher(appId, {
      cluster: cluster,
      encrypted: true,
      authEndpoint: '/api/pusher/auth'
    });
  }
  bindPublic(channelId, event, callBack) {
    var channel = this.pusher.subscribe(channelId);
    channel.bind(event, function (data) {
      callBack(data);
    });
  }
  bindPrivate(channelId, event, callBack) {
    var channel = this.pusher.subscribe("private-" + channelId);
    var $callback = callBack;
    channel.bind(event, function (data) {
      $callback(data);
    });
  }
  alreadyBoundPrivate(channelId) {
    var channel = this.pusher.channel("private-" + channelId);
    if (channel) {
      return true;
    }
    return false;
  }
}
class UserService {
  constructor() {}
  getPreference(preferenceKey, doneFunction, failFunction, alwaysFunction) {
    $.getJSON(`/api/User/Preference/${preferenceKey}`).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
  updatePreference(preferenceKey, preferenceData, doneFunction, failFunction, alwaysFunction) {
    $.ajax({
      url: `/api/User/Preference/${preferenceKey}`,
      type: 'POST',
      data: JSON.stringify(preferenceData),
      contentType: "application/json",
      dataType: "json"
    }).done(function (json) {
      if (doneFunction) doneFunction(json);
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed: " + err);
      if (failFunction) failFunction(jqxhr, textStatus, error);
    }).always(function () {
      if (alwaysFunction) alwaysFunction();
    });
  }
}
class UserTasksService {
  constructor() {}
  getTasks(taskFilter) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/Tasks/`, {
        params: {
          taskFilter: taskFilter
        }
      }).then(response => {
        resolve({
          tasks: response.data.tasks
        });
      }).catch(function (error) {
        reject({
          error: error
        });
      });
    });
  }
  addTaskPrompt(userIds, personIds, organizationIds) {
    return new Promise((resolve, reject) => {
      if (personIds && personIds.length > 0) {
        //only supporting one for now
        axios.get(`/api/Persons/v2/${personIds[0]}`).then(response => {
          var template = {
            persons: [response.data]
          };
          this._addTaskPrompt(resolve, reject, userIds, personIds, organizationIds, template);
        }).catch(function (error) {
          var err = textStatus + ", " + error;
          console.log("Request Failed: " + err);
          if (failFunction) failFunction(jqxhr, textStatus, error);
        }).finally(function () {});
      } else {
        this._addTaskPrompt(resolve, reject, userIds, personIds, organizationIds);
      }
    });
  }
  _addTaskPrompt(resolve, reject, userIds, personIds, organizationIds, templateData) {
    var template = ejs.render(`${this._taskTemplate()}`, {});
    var personService = new PersonService();
    Swal.fire({
      title: 'Add Task',
      html: template,
      //footer: "<div>A reply-to is not required. If left blank, replies will go to the email address it was sent from.</div>",
      focusConfirm: false,
      confirmButtonText: "Create Task",
      width: "auto",
      showCancelButton: true,
      customClass: {
        popup: "cd-swal-lg"
      },
      onRender: x => {
        $("#TaskDueDate").val(this._buildNextValidDate(1, "MM/DD/YYYY"));
        $("#TaskEmailReminder").val(this._buildNextValidDate(1, "MM/DD/YYYY"));
        $("#TaskDueDate").on("change", e => {
          $("#TaskEmailReminder").val($("#TaskDueDate").val());
        });
        $("#TaskDueDate").on("keyup", e => {
          $("#TaskEmailReminder").val($("#TaskDueDate").val());
        });
        $("#TaskDueDate").datepicker({
          format: "mm/dd/yyyy",
          autoclose: true,
          orientation: "bottom",
          assumeNearbyYear: true
        });
        $("#TaskEmailReminder").datepicker({
          format: "mm/dd/yyyy",
          autoclose: true,
          orientation: "up",
          assumeNearbyYear: true
        });
        $("#TaskAssignedPersons").select2({
          allowClear: true,
          minimumResultsForSearch: 2,
          minimumInputLength: 2,
          width: "100%",
          placeholder: "Search...",
          ajax: {
            transport: function (params, success, failure) {
              axios.get('/api/Suggest/People', {
                params: {
                  term: params.data.term
                }
              }).then(function (response) {
                var persons = response.data.map(function (x) {
                  return {
                    id: x.personId,
                    text: x.personName.fullName,
                    person: x
                  };
                });
                var promise = new Promise(function (resolve, reject) {
                  resolve({
                    results: persons
                  });
                });
                promise.then(success);
                promise.catch(failure);
              }).catch(function (error) {
                toastr.error("Error getting People");
              });
            }
          },
          templateResult: function (item) {
            if (!item.id) {
              return "";
            }
            return $(`<span>${CDXss.sanatizeInput(item.text)}<br/>${CDXss.sanatizeInput(item.person.address.deliveryLine1)}</span>`);
          }
        });
        if (templateData && templateData.persons) {
          for (var i = 0; i < templateData.persons.length; i++) {
            var newOption = new Option(templateData.persons[i].name.fullName, templateData.persons[i].personId, false, false);
            $('#TaskAssignedPersons').append(newOption).val(templateData.persons[i].personId).trigger("change");
          }
        }
        axios.post('/api/User/Users').then(function (response) {
          var users = response.data.map(function (x) {
            return {
              id: x.userId,
              text: (x.firstName || "") + " " + (x.lastName || "")
            };
          });
          $("#AssignedUsers").select2({
            width: "100%",
            data: users
          });
          if (userIds) {
            $('#AssignedUsers').val(userIds);
            $('#AssignedUsers').trigger('change');
          }
        }).catch(function (error) {
          toastr.error("Error getting current users");
        });
      },
      preConfirm: () => {
        if (cdeputyIsEmptyOrSpaces(document.getElementById('TaskTitle').value) === true) {
          Swal.showValidationMessage(`A Title is required.`);
          return false;
        }
        if ($("#AssignedUsers").val().length === 0) {
          Swal.showValidationMessage(`A task must be assigned to a User to be created.`);
          return false;
        }
        return {
          TaskTitle: document.getElementById('TaskTitle').value,
          TaskTypeId: document.getElementById('TaskTypeId').value,
          TaskDueDate: document.getElementById('TaskDueDate').value,
          TaskDescription: document.getElementById('TaskDescription').value,
          TaskEmailReminder: document.getElementById('TaskEmailReminder').value,
          AssignedUsers: $("#AssignedUsers").val(),
          //need the array
          AssignedPersons: $("#TaskAssignedPersons").val() //need the array
        };
      }
    }).then(result => {
      if (result.value) {
        var task = result.value;
        axios.post('/api/Tasks/', {
          TaskTypeId: task.TaskTypeId,
          Title: task.TaskTitle,
          Description: task.TaskDescription,
          DueDateUTC: task.TaskDueDate,
          AssignedUsers: task.AssignedUsers,
          AssignedPersons: task.AssignedPersons,
          EmailReminder1UTC: task.TaskEmailReminder
        }).then(function (response) {
          toastr.success("Added Task");
          resolve({
            task: response.data.task
          });
        }).catch(function (error) {
          toastr.error("Error Adding Task");
          reject({
            error: error
          });
        });
      }
    });
  }
  editTaskPrompt(taskId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/Tasks/${taskId}`).then(response => {
        var template = ejs.render(`${this._taskTemplate()}`, {});
        var usersTask = response.data.task;
        Swal.fire({
          title: 'Edit Task',
          html: template,
          focusConfirm: false,
          confirmButtonText: "Save Task",
          width: "auto",
          showCancelButton: true,
          customClass: {
            popup: "cd-swal-lg"
          },
          onRender: x => {
            axios.post('/api/User/Users').then(function (response) {
              var users = response.data.map(function (x) {
                return {
                  id: x.userId,
                  text: (x.firstName || "") + " " + (x.lastName || "")
                };
              });
              $("#AssignedUsers").select2({
                width: "100%",
                data: users
              });
              if (usersTask.assignedUsers) {
                $('#AssignedUsers').val(usersTask.assignedUsers).trigger('change');
              }
            }).catch(function (error) {
              toastr.error("Error getting current users");
            });
            $("#TaskTitle").val(usersTask.title);
            $("#TaskTypeId").val(usersTask.taskTypeId);
            $("#TaskDescription").val(usersTask.description);
            //$("#AssignedUsers").val(usersTask.DueDateUTC);
            //$("#TaskAssignedPersons").val(usersTask.DueDateUTC);
            if (usersTask.dueDateUTC) {
              $("#TaskDueDate").val(moment(usersTask.dueDateUTC).format("MM/DD/YYYY"));
            }
            if (usersTask.emailReminder1UTC) {
              $("#TaskEmailReminder").val(moment(usersTask.emailReminder1UTC).format("MM/DD/YYYY"));
            }
            $("#TaskDueDate").on("change", e => {
              $("#TaskEmailReminder").val($("#TaskDueDate").val());
            });
            $("#TaskDueDate").on("keyup", e => {
              $("#TaskEmailReminder").val($("#TaskDueDate").val());
            });
            $("#TaskDueDate").datepicker({
              format: "mm/dd/yyyy",
              autoclose: true,
              orientation: "bottom",
              assumeNearbyYear: true
            });
            $("#TaskEmailReminder").datepicker({
              format: "mm/dd/yyyy",
              autoclose: true,
              orientation: "up",
              assumeNearbyYear: true
            });
            $("#TaskAssignedPersons").select2({
              allowClear: true,
              minimumResultsForSearch: 2,
              minimumInputLength: 2,
              width: "100%",
              placeholder: "Search...",
              ajax: {
                transport: function (params, success, failure) {
                  axios.get('/api/Suggest/People', {
                    params: {
                      term: params.data.term
                    }
                  }).then(function (response) {
                    var persons = response.data.map(function (x) {
                      return {
                        id: x.personId,
                        text: x.personName.fullName,
                        person: x
                      };
                    });
                    var promise = new Promise(function (resolve, reject) {
                      resolve({
                        results: persons
                      });
                    });
                    promise.then(success);
                    promise.catch(failure);
                  }).catch(function (error) {
                    toastr.error("Error getting People");
                  });
                }
              },
              templateResult: function (item) {
                if (!item.id) {
                  return "";
                }
                return $(`<span>${CDXss.sanatizeInput(item.text)}<br/>${CDXss.sanatizeInput(item.person.address.deliveryLine1)}</span>`);
              }
            });
            if (usersTask.assignedPersons) {
              for (var i = 0; i < usersTask.assignedPersons.length; i++) {
                var newOption = new Option(usersTask.assignedPersons[i].displayValue, usersTask.assignedPersons[i].personId, false, false);
                $('#TaskAssignedPersons').append(newOption);
              }
              $('#TaskAssignedPersons').val(usersTask.assignedPersons.map(m => m.personId)).trigger("change"); //need to set it to the array
            }
          },

          preConfirm: () => {
            if (cdeputyIsEmptyOrSpaces(document.getElementById('TaskTitle').value) === true) {
              Swal.showValidationMessage(`A Title is required.`);
              return false;
            }
            if ($("#AssignedUsers").val().length === 0) {
              Swal.showValidationMessage(`A task must be assigned to a User to be created.`);
              return false;
            }
            return {
              TaskTitle: document.getElementById('TaskTitle').value,
              TaskTypeId: document.getElementById('TaskTypeId').value,
              TaskDueDate: document.getElementById('TaskDueDate').value,
              TaskDescription: document.getElementById('TaskDescription').value,
              TaskEmailReminder: document.getElementById('TaskEmailReminder').value,
              AssignedUsers: $("#AssignedUsers").val(),
              //need the array
              AssignedPersons: $("#TaskAssignedPersons").val() //need the array
            };
          }
        }).then(result => {
          if (result.value) {
            var task = result.value;
            axios.post(`/api/Tasks/${usersTask.taskId}`, {
              TaskTypeId: task.TaskTypeId,
              Title: task.TaskTitle,
              Description: task.TaskDescription,
              DueDateUTC: task.TaskDueDate,
              AssignedUsers: task.AssignedUsers,
              AssignedPersons: task.AssignedPersons,
              EmailReminder1UTC: task.TaskEmailReminder
            }).then(function (response) {
              toastr.success("Task Saved");
              resolve({
                task: response.data.tasks
              });
            }).catch(function (error) {
              Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                icon: "error",
                title: "Error saving Task"
              });
              reject({
                error: error
              });
            });
          }
        });
      }).catch(function (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong retrieving your task!'
        });
        reject({
          error: error
        });
      });
    });
  }
  completeTaskPrompt(taskId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/Tasks/${taskId}`).then(response => {
        var template = ejs.render(`${this._taskTemplate()}`, {});
        var usersTask = response.data.task;
        Swal.fire({
          title: 'Complete Task',
          html: template,
          focusConfirm: false,
          confirmButtonText: "Complete Task",
          width: "auto",
          showCancelButton: true,
          customClass: {
            popup: "cd-swal-lg"
          },
          onRender: x => {
            this._internalRender(usersTask);
          },
          preConfirm: () => {
            if (cdeputyIsEmptyOrSpaces(document.getElementById('TaskTitle').value) === true) {
              Swal.showValidationMessage(`A Title is required.`);
              return false;
            }
            if ($("#AssignedUsers").val().length === 0) {
              Swal.showValidationMessage(`A task must be assigned to a User to be created.`);
              return false;
            }
            return {
              TaskTitle: document.getElementById('TaskTitle').value,
              TaskTypeId: document.getElementById('TaskTypeId').value,
              TaskDueDate: document.getElementById('TaskDueDate').value,
              TaskDescription: document.getElementById('TaskDescription').value,
              TaskEmailReminder: document.getElementById('TaskEmailReminder').value,
              AssignedUsers: $("#AssignedUsers").val(),
              //need the array
              AssignedPersons: $("#TaskAssignedPersons").val() //need the array
            };
          }
        }).then(result => {
          if (result.value) {
            var task = result.value;
            axios.post(`/api/Tasks/Complete/${usersTask.taskId}`, {
              TaskTypeId: task.TaskTypeId,
              Title: task.TaskTitle,
              Description: task.TaskDescription,
              DueDateUTC: task.TaskDueDate,
              AssignedUsers: task.AssignedUsers,
              AssignedPersons: task.AssignedPersons,
              EmailReminder1UTC: task.TaskEmailReminder
            }).then(function (response) {
              toastr.success("Task Marked as Completed");
              resolve({
                task: response.data.tasks
              });
            }).catch(function (error) {
              Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                icon: "error",
                title: "Error saving Task"
              });
              reject({
                error: error
              });
            });
          }
        });
      }).catch(function (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong retrieving your task!'
        });
        reject({
          error: error
        });
      });
    });
  }
  _internalRender(usersTask) {
    axios.post('/api/User/Users').then(function (response) {
      var users = response.data.map(function (x) {
        return {
          id: x.userId,
          text: (x.firstName || "") + " " + (x.lastName || "")
        };
      });
      $("#AssignedUsers").select2({
        width: "100%",
        data: users
      });
      if (usersTask.assignedUsers) {
        $('#AssignedUsers').val(usersTask.assignedUsers).trigger('change');
      }
    }).catch(function (error) {
      toastr.error("Error getting current users");
    });
    $("#TaskTitle").val(usersTask.title);
    $("#TaskTypeId").val(usersTask.taskTypeId);
    $("#TaskDescription").val(usersTask.description);
    //$("#AssignedUsers").val(usersTask.DueDateUTC);
    //$("#TaskAssignedPersons").val(usersTask.DueDateUTC);
    if (usersTask.dueDateUTC) {
      $("#TaskDueDate").val(moment(usersTask.dueDateUTC).format("MM/DD/YYYY"));
    }
    if (usersTask.emailReminder1UTC) {
      $("#TaskEmailReminder").val(moment(usersTask.emailReminder1UTC).format("MM/DD/YYYY"));
    }
    $("#TaskDueDate").on("change", e => {
      $("#TaskEmailReminder").val($("#TaskDueDate").val());
    });
    $("#TaskDueDate").on("keyup", e => {
      $("#TaskEmailReminder").val($("#TaskDueDate").val());
    });
    $("#TaskDueDate").datepicker({
      format: "mm/dd/yyyy",
      autoclose: true,
      orientation: "bottom",
      assumeNearbyYear: true
    });
    $("#TaskEmailReminder").datepicker({
      format: "mm/dd/yyyy",
      autoclose: true,
      orientation: "up",
      assumeNearbyYear: true
    });
    $("#TaskAssignedPersons").select2({
      allowClear: true,
      minimumResultsForSearch: 2,
      minimumInputLength: 2,
      width: "100%",
      placeholder: "Search...",
      ajax: {
        transport: function (params, success, failure) {
          axios.get('/api/Suggest/People', {
            params: {
              term: params.data.term
            }
          }).then(function (response) {
            var persons = response.data.map(function (x) {
              return {
                id: x.personId,
                text: x.personName.fullName,
                person: x
              };
            });
            var promise = new Promise(function (resolve, reject) {
              resolve({
                results: persons
              });
            });
            promise.then(success);
            promise.catch(failure);
          }).catch(function (error) {
            toastr.error("Error getting People");
          });
        }
      },
      templateResult: function (item) {
        if (!item.id) {
          return "";
        }
        return $(`<span>${CDXss.sanatizeInput(item.text)}<br/>${CDXss.sanatizeInput(item.person.address.deliveryLine1)}</span>`);
      }
    });
    if (usersTask.assignedPersons) {
      for (var i = 0; i < usersTask.assignedPersons.length; i++) {
        var newOption = new Option(usersTask.assignedPersons[i].displayValue, usersTask.assignedPersons[i].personId, false, false);
        $('#TaskAssignedPersons').append(newOption);
      }
      $('#TaskAssignedPersons').val(usersTask.assignedPersons.map(m => m.personId)).trigger("change"); //need to set it to the array
    }
  }

  deleteTaskPrompt(taskId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/Tasks/${taskId}`).then(response => {
        var template = ejs.render(`${this._taskTemplate()}`, {});
        var usersTask = response.data.task;
        Swal.fire({
          title: 'Delete Task?',
          html: template,
          focusConfirm: false,
          confirmButtonText: "Delete Task",
          width: "auto",
          showCancelButton: true,
          customClass: {
            popup: "cd-swal-lg"
          },
          onRender: x => {
            this._internalRender(usersTask);
          },
          preConfirm: () => {
            if (cdeputyIsEmptyOrSpaces(document.getElementById('TaskTitle').value) === true) {
              Swal.showValidationMessage(`A Title is required.`);
              return false;
            }
            if ($("#AssignedUsers").val().length === 0) {
              Swal.showValidationMessage(`A task must be assigned to a User to be created.`);
              return false;
            }
            return {
              TaskTitle: document.getElementById('TaskTitle').value,
              TaskTypeId: document.getElementById('TaskTypeId').value,
              TaskDueDate: document.getElementById('TaskDueDate').value,
              TaskDescription: document.getElementById('TaskDescription').value,
              TaskEmailReminder: document.getElementById('TaskEmailReminder').value,
              AssignedUsers: $("#AssignedUsers").val(),
              //need the array
              AssignedPersons: $("#TaskAssignedPersons").val() //need the array
            };
          }
        }).then(result => {
          if (result.value) {
            var task = result.value;
            axios.post(`/api/Tasks/Complete/${usersTask.taskId}`, {
              TaskTypeId: task.TaskTypeId,
              Title: task.TaskTitle,
              Description: task.TaskDescription,
              DueDateUTC: task.TaskDueDate,
              AssignedUsers: task.AssignedUsers,
              AssignedPersons: task.AssignedPersons,
              EmailReminder1UTC: task.TaskEmailReminder
            }).then(function (response) {
              toastr.success("Task Saved");
              resolve({
                task: response.data.tasks
              });
            }).catch(function (error) {
              Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                icon: "error",
                title: "Error saving Task"
              });
              reject({
                error: error
              });
            });
          }
        });
      }).catch(function (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong retrieving your task!'
        });
        reject({
          error: error
        });
      });
    });
  }
  _buildNextValidDate(daysToIncrement, dateFormat) {
    if (moment().day() === 5) {
      dayIncrement = 3; // set to monday
    } else if (moment().day() === 6) {
      dayIncrement = 2; // set to monday
    }

    return moment().add(daysToIncrement, 'd').format(dateFormat);
  }
  _taskTemplate() {
    return '<form class="form-add-call text-left"><div class="form-row mx-0"><div class="col-12 col-sm-6 col-md-6"><label class="control-label">Title</label><input type="text" id="TaskTitle" name="TaskTitle" class="form-control" placeholder="Name for Task"/> </div><div class="col-12 col-sm-6 col-md-3"> <label class="control-label">Task Type</label><select id="TaskTypeId" name="TaskTypeId" class="form-control"> <option value="1">Task</option> @*<option value="1">Call</option>*@ </select> </div><div class="col-12 col-md-3"> <label class="control-label">Due Date</label> <div class="input-group date"> <div class="input-group-addon"><TaskDueDate class="input-group-text"><i class="fa fa-calendar"></i></TaskDueDate></div><input name="TaskDueDate" id="TaskDueDate" class="form-control datepicker px-1" type="text" placeholder="MM/DD/YYYY" value=""/> </div></div></div><div class="form-row mx-0 my-2"> <div class="col-12"> <label class="control-label">Description</label> <textarea id="TaskDescription" name="TaskDescription" class="form-control" rows="5" placeholder="Notes..." ></textarea> </div></div><div class="form-row mx-0 my-2"> <div class="col-12"> <label class="control-label">Associated with</label><% if (locals.persons) { %><% persons.forEach(function(person){%><div><%=person.name.fullName%></div><% }); %><% } %><div class="input-group"><select class="form-control" id="TaskAssignedPersons" name="TaskAssignedPersons" multiple></select></div></div></div><div class="form-row mx-0 my-2"> <div class="col-12 col-sm-6 col-md-3"> <label class="control-label">Email Reminder</label> <div class="input-group date"> <div class="input-group-addon"><span class="input-group-text"><i class="fa fa-calendar"></i></span></div><input name="TaskEmailReminder" id="TaskEmailReminder" class="form-control datepicker px-1" type="text" placeholder="MM/DD/YYYY" value=""/> </div></div><div class="col-12 col-sm-6 col-md-9"> <label class="control-label">Assigned To</label> <div class="input-group date"> <select id="AssignedUsers" class=" form-control" multiple="multiple" placeholder="Search..."></select> </div></div></div></form>';
  }
}